import { list } from 'https://cdn.venturz.co/lib/redom.es.js';

import FormFieldRow from './field-row/index.js';

class FormFieldRenderer {

  constructor(configuration) {

    this.formId = configuration.formId;
    this.page = configuration.page;

    const container = list('div.form-editor-field-rows', FormFieldRow, null, this);

    container.update(configuration.fieldRows);

    this.el = container;

  }

}

export default FormFieldRenderer;